module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expand-transition', [(_vm.isVisible) ? _c('div', {
    style: (_vm.blockStyle(_vm.schema)),
    attrs: {
      "title": _vm.schema.name
    },
    on: {
      "click": _vm.formBlockClicked
    }
  }, [(_vm.controlName) ? _c(_vm.controlName, {
    tag: "component",
    attrs: {
      "schema": _vm.mergedSchema,
      "value": _vm.value,
      "context": _vm.context
    },
    on: {
      "change": _vm.change,
      "focus": _vm.focus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldRenderFields) ? _c('div', {
    staticClass: "control-group",
    class: {
      horizontal: _vm.horizontal
    }
  }, [_vm._l((_vm.childFields), function(field, fieldIndex) {
    return [_c('FormBlock', {
      key: fieldIndex,
      attrs: {
        "schema": field,
        "value": _vm.value,
        "horizontal": _vm.schema.horizontal,
        "context": _vm.context
      },
      on: {
        "change": _vm.change,
        "focus": _vm.focus
      }
    })]
  })], 2) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05419379"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/FormBlock.vue
// module id = 2432
// module chunks = 1